const sailthruSignUp = (signupValues) => {
  if (window.Sailthru && typeof window.Sailthru === 'object') {
    window.Sailthru.integration('userSignUp', signupValues);
  }
};

export default sailthruSignUp;
